module.exports = __webpack_public_path__ + "17e7b804dcef54a965324ab9abc241c2.svg";